import Layout from '@/layouts'
import {i18n} from "@/utils/i18n";

const paymentType = {
  path: '/ProductsWarehouses',
  component: Layout,
  name: 'ProductsWarehouses',
  redirect: '/ProductsWarehouses/index',
  children: [{
    path: '/ProductsWarehouses/index',
    component: () => import('@/views/ProductsWarehouses/index'),
    name: 'ProductsWarehouses.index',
    meta: {
      title: i18n.t(`message.products`)
    }
  }, ]
}

export default paymentType